import { createHttpHeader } from '@/utils/network/createHTTPHeaders';
import { decryptTreezorResponse } from '@/services/encryption/decryptTreezorResponse';
import { IPayin, IPayinFilters } from '@/store/models/payin.model';
import { getStaticDashboardConfig } from '@/hooks/useDashboardConfig';
import { fetchQuery } from '@/utils/queryClient';
import { fetchMethods } from '@/types/FetchService.types';

export class PayinService {
  static queryKey = 'Payin';
  static getPayins = async (filters: IPayinFilters): Promise<IPayin[]> => {
    try {
      const config = getStaticDashboardConfig();
      const headers = createHttpHeader();

      const params = new URLSearchParams();

      if (filters.walletId) params.set('walletId', filters.walletId);
      if (filters.payinStatus) params.set('paymentMethodId', filters.payinStatus);
      if (filters.paymentMethodId) params.set('paymentMethodId', filters.paymentMethodId);

      const url = `${config.api.baseUrl}/v1/payins?${params.toString()}`;

      const response = await fetchQuery(
        [this.queryKey, { method: fetchMethods.GET, params: Object.fromEntries(params) }],
        url,
        { headers },
      );

      const payins = await decryptTreezorResponse<IPayin>(response);
      return payins;
    } catch (err) {
      return Promise.reject(err);
    }
  };
}
